module.exports = __webpack_public_path__ + "img/cover-not-found.e5c709d0.jpg";